import { useToast } from '@components/index'
import { apiClient } from '@services/api-client'
import { SNA_PREFIX } from '@services/utils'
import { useOnError } from '@services/utils/onError'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'

import { rentAmendmentsQueryKey } from '../queries/useRentAmendments'
import type { DepositAmendmentBody, RentAmendment } from '../types'

export function useCreateDepositAmendment() {
  const queryClient = useQueryClient()
  const toast = useToast()
  const { t } = useTranslation('toast')
  const onError = useOnError()

  async function createDepositAmendment(body: DepositAmendmentBody) {
    const res = await apiClient.post<RentAmendment>(
      `${SNA_PREFIX}rent-amendments/deposit`,
      body
    )
    return res.data
  }

  return useMutation({
    mutationFn: createDepositAmendment,
    onSuccess: () => {
      toast.success({ message: t('rentAmendmentSent') })
      queryClient.invalidateQueries({ queryKey: rentAmendmentsQueryKey })
    },
    onError
  })
}
